module.exports = __webpack_public_path__ + "static/media/sunflower-6.99bc00f4.jpg";